let themeDefined = false;

export const defineCustomTheme = (monaco) => {
  if (themeDefined) {
    return;
  }

  themeDefined = true;

  monaco.editor.defineTheme("customTheme", {
    base: "vs",
    inherit: true,
    rules: [
      { token: "", foreground: "000000", background: "FFFFFF" },
      { token: "keyword", foreground: "0000CC", fontStyle: "bold" },
      { token: "number", foreground: "AA0000" },
      { token: "string", foreground: "006400" },
      { token: "comment", foreground: "6A9955", fontStyle: "italic" },
      { token: "identifier", foreground: "111111" },
      { token: "keyword", foreground: "00008B", fontStyle: "bold" },
      { token: "operator", foreground: "000000" },
      { token: "type", foreground: "2B91AF" },
      { token: "function", foreground: "795E26" },
      { token: "variable", foreground: "333333" },
    ],
    colors: {
      "editor.background": "#F5F5F5",
      "editor.foreground": "#000000",
      "editorLineNumber.foreground": "#777777",
      "editorLineNumber.activeForeground": "#333333",
      "editorCursor.foreground": "#000000",
      "editor.selectionBackground": "#CDE3FF",
      "editor.inactiveSelectionBackground": "#E8F0FF",
      "editorIndentGuide.background": "#E0E0E0",
      "editorIndentGuide.activeBackground": "#A0A0A0",
      "editorLineHighlight.background": "#F5F9FF",
      "editorLineHighlightBorder": "#E6EEFF",
      "editorHoverWidget.background": "#FFFFFF",
      "editorWidget.background": "#FFFFFF",
      'editorOverviewRuler.background': '#f7f7f7',
    },
  });
};
